<canvas id="cloudCoverContainer_999" width=350 height=350></canvas>
